export default {"src":"/assets/_next/static/media/de.e28dff83.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};